// @ts-nocheck
export default (sizeVariant?: string) => {
    switch (sizeVariant) {
        case "default":
            return "medium"; // Store Custom Code
        case "small":
            return "small"; // Store Custom Code
        case "xsmall":
            return undefined; // Store Custom Code
        default:
            return undefined;
    }
};
